// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__20SNy","emails":"CreateEditClinics_emails__3_k1t","emailTagLabel":"CreateEditClinics_emailTagLabel__4Jwj3"};